module.exports = __webpack_public_path__ + "media/images/amenities_icons/onsite-restaurant-6692835a54513d458c523a097c7c1f45.svg";